import { render, staticRenderFns } from "./GridRentasByCatalogo.vue?vue&type=template&id=b20573f2&"
import script from "./GridRentasByCatalogo.vue?vue&type=script&lang=js&"
export * from "./GridRentasByCatalogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports